import React from 'react'
import type { IconDefaultProps } from '../../models/types'

const AgendaIcon = ({ className, color }: IconDefaultProps): JSX.Element => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={className || 'rf-h-6 rf-w-8'}
      viewBox='0 0 63.265 64.381'
    >
      <g transform='translate(-28.3 -17.5)'>
        <g transform='translate(28.3 17.5)'>
          <path
            d='M88.408,23.284H86.149V21.174a3.674,3.674,0,1,0-7.348,0v2.109H71.207V21.174a3.674,3.674,0,0,0-7.348,0v2.109h-7.77V21.174a3.674,3.674,0,1,0-7.348,0v2.109H41.051V21.174a3.674,3.674,0,1,0-7.348,0v2.109H31.457A3.159,3.159,0,0,0,28.3,26.441V78.71a3.171,3.171,0,0,0,3.157,3.171H88.408a3.162,3.162,0,0,0,3.157-3.171V26.454A3.154,3.154,0,0,0,88.408,23.284Zm-7.879-2.109a1.946,1.946,0,1,1,3.892,0v2.109H80.542V21.174Zm-14.928,0a1.946,1.946,0,1,1,3.892,0v2.109H65.614V21.174Zm-15.119,0a1.946,1.946,0,1,1,3.892,0v2.109H50.5V21.174Zm-15.024,0a1.946,1.946,0,1,1,3.892,0v2.109H35.458Zm-4,3.878h2.286v2.286a3.676,3.676,0,0,0,3.674,3.674.857.857,0,1,0,0-1.715,1.946,1.946,0,0,1-1.946-1.946v-2.3h13.3v2.286a3.676,3.676,0,0,0,3.674,3.674.857.857,0,0,0,0-1.715A1.946,1.946,0,0,1,50.5,27.352v-2.3H63.886v2.286a3.676,3.676,0,0,0,3.674,3.674.857.857,0,0,0,0-1.715,1.946,1.946,0,0,1-1.946-1.946v-2.3h13.2v2.286a3.676,3.676,0,0,0,3.674,3.674.857.857,0,1,0,0-1.715,1.946,1.946,0,0,1-1.946-1.946v-2.3h7.866a1.4,1.4,0,0,1,1.4,1.4v7.267H30.055V26.454A1.4,1.4,0,0,1,31.457,25.053ZM88.408,80.125H31.457a1.4,1.4,0,0,1-1.4-1.4V35.436H89.823V78.724A1.42,1.42,0,0,1,88.408,80.125Z'
            transform='translate(-28.3 -17.5)'
            fill={color || '#865da2'}
          />
          <path
            d='M97.775,229.7H90.182a2.082,2.082,0,0,0-2.082,2.082v7.92a2.082,2.082,0,0,0,2.082,2.082h7.593a2.082,2.082,0,0,0,2.082-2.082v-7.92A2.091,2.091,0,0,0,97.775,229.7Zm.354,10.016a.351.351,0,0,1-.354.354H90.182a.351.351,0,0,1-.354-.354V231.8a.351.351,0,0,1,.354-.354h7.593a.351.351,0,0,1,.354.354Z'
            transform='translate(-79.962 -200.823)'
            fill={color || '#865da2'}
          />
          <path
            d='M226.775,229.7h-7.593a2.082,2.082,0,0,0-2.082,2.082v7.92a2.082,2.082,0,0,0,2.082,2.082h7.593a2.082,2.082,0,0,0,2.082-2.082v-7.92A2.082,2.082,0,0,0,226.775,229.7Zm.354,10.016a.351.351,0,0,1-.354.354h-7.593a.351.351,0,0,1-.354-.354V231.8a.351.351,0,0,1,.354-.354h7.593a.351.351,0,0,1,.354.354Z'
            transform='translate(-191.408 -200.823)'
            fill={color || '#865da2'}
          />
          <path
            d='M356.389,229.7h-7.607a2.082,2.082,0,0,0-2.082,2.082v7.92a2.082,2.082,0,0,0,2.082,2.082h7.593a2.082,2.082,0,0,0,2.082-2.082v-7.92A2.07,2.07,0,0,0,356.389,229.7Zm.354,10.016a.351.351,0,0,1-.354.354h-7.607a.351.351,0,0,1-.354-.354V231.8a.351.351,0,0,1,.354-.354h7.593a.351.351,0,0,1,.354.354v7.92Z'
            transform='translate(-303.371 -200.823)'
            fill={color || '#865da2'}
          />
          <path
            d='M97.775,340.8H90.182a2.082,2.082,0,0,0-2.082,2.082v7.92a2.082,2.082,0,0,0,2.082,2.082h7.593a2.082,2.082,0,0,0,2.082-2.082v-7.92A2.091,2.091,0,0,0,97.775,340.8Zm.354,10.016a.351.351,0,0,1-.354.354H90.182a.351.351,0,0,1-.354-.354V342.9a.351.351,0,0,1,.354-.354h7.593a.351.351,0,0,1,.354.354Z'
            transform='translate(-79.962 -296.804)'
            fill={color || '#865da2'}
          />
          <path
            d='M226.775,340.8h-7.593a2.082,2.082,0,0,0-2.082,2.082v7.92a2.082,2.082,0,0,0,2.082,2.082h7.593a2.082,2.082,0,0,0,2.082-2.082v-7.92A2.082,2.082,0,0,0,226.775,340.8Zm.354,10.016a.351.351,0,0,1-.354.354h-7.593a.351.351,0,0,1-.354-.354V342.9a.351.351,0,0,1,.354-.354h7.593a.351.351,0,0,1,.354.354Z'
            transform='translate(-191.408 -296.804)'
            fill={color || '#865da2'}
          />
          <path
            d='M356.389,340.8h-7.607a2.082,2.082,0,0,0-2.082,2.082v7.92a2.082,2.082,0,0,0,2.082,2.082h7.593a2.082,2.082,0,0,0,2.082-2.082v-7.92A2.07,2.07,0,0,0,356.389,340.8Zm.354,10.016a.351.351,0,0,1-.354.354h-7.607a.351.351,0,0,1-.354-.354V342.9a.351.351,0,0,1,.354-.354h7.593a.351.351,0,0,1,.354.354v7.92Z'
            transform='translate(-303.371 -296.804)'
            fill={color || '#865da2'}
          />
          <path
            d='M162.957,175.715h30.768a.857.857,0,0,0,0-1.715H162.957a.857.857,0,0,0,0,1.715Z'
            transform='translate(-143.892 -152.703)'
            fill={color || '#865da2'}
          />
          <circle
            cx='1.129'
            cy='1.129'
            r='1.129'
            transform='translate(12.548 21.515) rotate(-13.286)'
            fill={color || '#865da2'}
          />
        </g>
      </g>
    </svg>
  )
}

export default AgendaIcon
